<template>
  <v-container
    id="demo"
    tag="section"
  >
    <base-subheading
      class="mb-12 primary--text"
      tag="h1"
      title="Interactive Demo"
    />

    <v-row
      class="mb-6"
      justify="center"
    >
      <v-col
        cols="12"
        md="7"
        class="headline font-weight-light"
      >
        <p>
          Pressing the button below will launch an interactive demo for a sample Billit Build. The Build is the interface that regular staff uses in order to interact with their organization’s Billit setup, such as viewing the list of their organization’s accepted insurance carriers and plans and their billing instructions for those plans, as well as using Billit’s insurance card tool to identify what insurance plan any card belongs to based on its appearance. Build is used by staff as a tool to correctly approach any billing situation.
        </p>

        <p>
          We've loaded the demo up with various example insurance carriers and example plans and instructions inside of each. Please explore the sidebar to see how the step-by-step process works, and to get a general feel of the product. Be sure to check out search and advanced search as well.
        </p>

        
      </v-col>
    </v-row>

    <v-container>
      <v-row class="mb-4" justify="center">
        <v-scroll-y-reverse-transition appear hide-on-leave>
          <v-col cols="12" md="7" v-show="!loading">
            <v-hover v-slot:default="{ hover }">
              <base-card
                :elevation="hover ? 8 : 0" style="cursor: pointer; border: 3px solid #55E6CC;"
                class="px-8 ml-n3 py-12" @click.native="toggleFullscreen"
              >
                <v-card-text>
                  <v-row>
                    <v-col
                      class="mt-4"
                      cols="12"
                    >
                      <div class="headline font-weight-bold primary--text mb-5">No need to book a meeting. Try it right now</div>
                      <!-- <span class="grey--text text-uppercase font-weight-bold">A tool to multiply the productivity of your team.</span> -->
                    </v-col>
                  </v-row>
                </v-card-text>
                <p style="position: absolute; bottom: 0; right: 0;" class="mr-8 text--uppercase font-weight-bold primary--text">
                  Enter the fullscreen demo
                  <v-icon color="primary" style="margin-top: 1px;">mdi-chevron-right</v-icon>
                </p>
              </base-card>
            </v-hover>
          </v-col>
        </v-scroll-y-reverse-transition>
        <v-progress-circular v-if="loading" indeterminate color="billit"></v-progress-circular>
      </v-row>
    </v-container>

    <v-row class="mb-12" justify="center">
      <v-col cols="12" md="7" class="headline font-weight-light">
        <div class="mb-12 font-italic body-1 font-weight-light text-center">
          The data presented in the demo is only for demonstrative purposes, and is not valid medical advice - or valid advice for anything for that matter.
          <div class="my-2"></div>
          Press the <code class="black--text mx-1">Esc</code> button on your keyboard at any time to leave the demo. If you have a privacy browser, please disable cookie-blocking.
        </div>

        <p>
          Support & advice for getting your team up to speed is available after signing in. If you have any questions please email us at <a target="_blank" href="mailto:hello@getbillit.com">hello@getbillit.com</a>
        </p>
      </v-col>
    </v-row>
    <!-- :src="`${process.env.VUE_APP_DEPLOYED_URL_BUILD} -->
    <!-- note: /demo only works in prod :( -->
    <!-- @load="loading = false" -->
    <iframe id="buildDemo" v-show="fullscreen" src="https://build.getbillit.com/?crossSiteFraudToken=TG9yZW0gaXBzdW0gZG9sb3Igc2l0IGFtZXQsIGNvbnNlY3RldHVyIGFkaXBpc2NpbmcgZWxpdCwgc2VkIGRvIGVpdXNtb2QgdGVtcG9yIGluY2lkaWR1bnQgdXQgbGFi&watchAuthentication=GV0IGRvbG9yZSBtYWduYSBhbGlxdWEuIFV0IGVuaW0gYWQgbWl&demo=b1ll1t&ensurancePolicyConfirmation=ZXUgZnVnaWF0IG51bGxhIHBhcmlhdHVyLiBFeGNlcHRldXIgc2ludCBvY2NhZWNhdCBjdXBpZGF0YXQgbm9uIHByb2lkZW50LCBzdW50IGluIGN1bHBhIHF1aSBvZmZpY2lhIGRlc2VydW50IG1vbGxpdCBhbmltIGlkIGVzdCBsYWJvcnVtLg" style="border: 0; width: 100vw; height: 100vh">Your browser isn't capable of running the demo. Please use a newer browser.</iframe>
  </v-container>
</template>

<script>
  export default {
    name: 'DemoIndex',

    data: () => ({
      fullscreen: false,
      frame: null,
      loading: true,
    }),
    mounted() {
      setTimeout(() => this.loading = false, 5000)
    },
    watch: {
      loading(loading) {
        if (!loading) {
          document.addEventListener('fullscreenchange', (event) => {
            // document.fullscreenElement will point to the element that
            // is in fullscreen mode if there is one. If there isn't one,
            // the value of the property is null.
            if (document.fullscreenElement) {
              this.fullscreen = true
              this.frame.contentWindow.postMessage({call:'sendValue', value: 'demoEnteredFullscreen'}, process.env.VUE_APP_DEPLOYED_URL_BUILD);
            } else {
              this.fullscreen = false
              this.loading = true
              this.frame.contentWindow.postMessage({call:'sendValue', value: 'demoLeftFullscreen'}, process.env.VUE_APP_DEPLOYED_URL_BUILD);
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
        }
      }
    },
    methods: {
      toggleFullscreen() {
        this.frame = document.getElementById('buildDemo')
        if (!document.fullscreenElement) {
          this.fullscreen = true
          this.frame.requestFullscreen().catch(err => {
            alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
          })
        } else {
          this.fullscreen = false
          document.exitFullscreen();
        }
      }
    }
  }
</script>
